/* Spanish catalog mirroring locale-autopilot-customers-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'ap.customerFollowup.title': 'Seguimiento de clientes',
  'ap.customerFollowup.waiting': 'Esperando respuesta',
  'ap.customerFollowup.ready': 'Listo para un presupuesto',
  'ap.customerFollowup.document': 'Presupuesto o pedido para seguimiento',
  'ap.customerFollowup.openChat': 'Abrir chat',
  'ap.customerFollowup.empty': 'Ahora mismo ningún cliente necesita seguimiento.',
});
